import { render, staticRenderFns } from "./upload-image.vue?vue&type=template&id=00de26d1&scoped=true&"
import script from "./upload-image.vue?vue&type=script&lang=js&"
export * from "./upload-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00de26d1",
  null
  
)

export default component.exports